import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import FrontendApp from './frontend-app/FrontendApp';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <FrontendApp />
  </StrictMode>
);
